// 通用分隔
// 用于input/textarea输入多个数据然后再分隔
export const separatorRe = / |,|;|\n|\t|，|；|、/;
export const emailRe = /^([A-Za-z0-9_\-\.\&\'])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,30})$/;
// admin patsnap 结尾校验
export const emailPatsnap = /patsnap.com$/;
export const patsnapOrZhihuiya = /(patsnap.com|zhihuiya.com)$/;
